import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/CalculatePaymentDueDate'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class CalculatePaymentDueDateStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "CalculatePaymentDueDateStore",
			variables: false,
		})
	}
}

export async function load_CalculatePaymentDueDate(params) {
  await initClient()

	const store = new CalculatePaymentDueDateStore()

	await store.fetch(params)

	return {
		CalculatePaymentDueDate: store,
	}
}
